module.exports = __webpack_public_path__ + "static/media/chart-scatter.746834d0.svg";